export default __webpack_public_path__ + "static/media/ts-3-2.2f4a0e9f.svg";